module.exports = __webpack_public_path__ + "static/media/group_19@3x.5d036b97.jpg";